import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KonPermission } from 'app/modules/UIKit/components/kontable/utility/utility-model';
import { ApplicationCompany } from '../../../../models/applicationCompany.model';
import { Company } from '../../../../models/company.model';
import { DataTableCustomButton } from '../../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { ApplicationService } from '../../../../services/application/applications.service';
import { CompaniesService } from '../../../../services/company/companies.service';

@Component({
  selector: 'app-company-applications',
  templateUrl: './companyApplications.component.html'
})
export class CompanyApplicationsComponent implements OnChanges, OnInit {

  @Output() onBackPressed: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectedApplications: ApplicationCompany[];
  @Input() activeCompany: Company;

  selectedApplicationsClone = [];
  customButtons: DataTableCustomButton[];
  companyApplicationsTitles: DataTableField[];
  perm: KonPermission = new KonPermission();
  newDataAvailable = false;
  showInfoModal =  false;
  companyApplication: ApplicationCompany;
  modalTitle = '';
  labels = {}

  constructor (
    private srvTranslate: TranslateService,
    private srvCompany: CompaniesService,
    private srvApplication: ApplicationService
  ) {
    this.srvTranslate.get(['companyApplications.applicationName', 'companyApplications.app_icon', 'companyApplications.msBaseUrl', 'common.back']).subscribe((res) => {
      this.companyApplicationsTitles = [
        {id: 'applicationName', label: res['companyApplications.applicationName'], notSortable: true},
        {id: 'app_icon', label: res['companyApplications.app_icon'], notSortable: true, editable: true},
        {id: 'msBaseUrl', label: res['companyApplications.msBaseUrl'], notSortable: true, editable: true},
      ];

      this.customButtons = [
        {label: res['common.back'], callbackname: 'back', icon: 'fa fa-angle-double-left', isAlwaysEnabled: true}
      ];

    });
  }

  ngOnInit(): void {

    this.srvTranslate.get([
      'applicationList.add_title',
      'applicationList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['applicationList.add_title'];
      this.labels['edit_title'] = res['applicationList.edit_title'];
    });

    this.perm.delete = false;
    this.perm.view = false;

  }

  ngOnChanges(changes) {
    if (changes.selectedApplications) {
      this.selectedApplicationsClone = [];
      changes.selectedApplications.currentValue.forEach((c) => {
        let clone = Object.assign({}, c);
        this.selectedApplicationsClone.push(clone);
      }, this);
    }
  }

  showDialog (data) {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];

    this.companyApplication = new ApplicationCompany();
    if (data) {
      this.companyApplication.msBaseUrl = data.msBaseUrl;
      this.companyApplication.app_icon = data.app_icon;
      this.companyApplication.id = data.id;
      this.companyApplication.applicationName = data.applicationName;
      this.companyApplication.applicationId = data.applicationId;
      this.companyApplication.companyId = data.companyId;
    } else {
      this.companyApplication.companyId = this.activeCompany.id;
    }
    this.showInfoModal = true;
  }

  onCustomButton() {
    this.onBackPressed.emit(true);
  }

  closeDialog () {
    this.modalTitle = '';
    this.showInfoModal = false;
  }

  refresh() {
    this.srvCompany.getApplications(this.activeCompany).subscribe((res) => {
      this.newDataAvailable = true;
      this.selectedApplicationsClone = res;
    });
  }

  companyApplicationsAdded (event) {
    this.srvCompany.postApplication(event).subscribe().add(() => {
      this.showInfoModal = false;
      this.refresh();
    });
  }

  companyApplicationsUpdated (event) {
    this.srvCompany.putApplication(event).subscribe().add(() => {
      this.showInfoModal = false;
      this.refresh();
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/views/administration/company/applications/companyApplications.component.ts